<template>
  <DrawerItem :icon="tabOutlineMessage2Exclamation" name="Feedback" @click="openDialog" />
</template>

<script setup>
import { tabOutlineMessage2Exclamation } from 'quasar-extras-svg-icons/tabler-icons-v3';
import DrawerItem from '../DrawerItem.vue';
import FeedbackDialog from './FeedbackDialog.vue';
import { useQuasar } from 'quasar';

const { dialog } = useQuasar();

const openDialog = () => {
  dialog({
    component: FeedbackDialog,
  });
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

.text-white {
  color: white;
}

.justify-center {
  justify-content: center;
}
</style>
